var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PromoView',{attrs:{"propContents":_vm.contents,"watchAction":_vm.watchContent,"getTitle":_vm.showPremieringDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }